import { render, staticRenderFns } from "./AddType.vue?vue&type=template&id=0331584b&scoped=true&"
import script from "./AddType.vue?vue&type=script&lang=js&"
export * from "./AddType.vue?vue&type=script&lang=js&"
import style0 from "./AddType.vue?vue&type=style&index=0&id=0331584b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0331584b",
  null
  
)

export default component.exports